var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "chart-table" }, [
    _c(
      "thead",
      _vm._l(_vm.dataTableChart.tableHead, function(item) {
        return _c("th", [
          _c("p", { staticClass: "text-medium" }, [_vm._v(_vm._s(item))])
        ])
      }),
      0
    ),
    _c(
      "tbody",
      _vm._l(_vm.dataTableChart.tableRows, function(row) {
        return _c("tr", [
          _c("td", [
            _c("p", { staticClass: "text-medium" }, [
              _vm._v(_vm._s(row.company))
            ])
          ]),
          _c("td", [
            _c("p", { staticClass: "text-medium" }, [
              _vm._v(_vm._s(row.username))
            ])
          ]),
          _c("td", [
            _c("p", { staticClass: "text-medium" }, [
              _vm._v(_vm._s(row.level1))
            ])
          ]),
          _c("td", [
            _c("p", { staticClass: "text-medium" }, [
              _vm._v(_vm._s(row.level2) + " ")
            ])
          ]),
          _c("td", [
            _c("p", { staticClass: "text-medium" }, [
              _vm._v(_vm._s(row.level3))
            ])
          ]),
          _c("td", [
            _c("p", { staticClass: "text-medium" }, [
              _vm._v(_vm._s(row.level4) + " ")
            ])
          ]),
          _c("td", [
            _c("div", { staticClass: "bar" }, [
              _c("div", { staticClass: "container-bar" }, [
                _c("div", {
                  staticClass: "bar-progress",
                  style: { width: row.percentage + "px" }
                })
              ]),
              _c("p", { staticClass: "text-medium" }, [
                _vm._v(_vm._s(row.percentage) + " %")
              ])
            ])
          ]),
          _c("td", [
            _c("div", { staticClass: "bar" }, [
              _c("div", { staticClass: "container-bar" }, [
                _c("div", {
                  staticClass: "bar-progress",
                  style: { width: row.avg + "px" }
                })
              ]),
              _c("p", { staticClass: "text-medium" }, [_vm._v(_vm._s(row.avg))])
            ])
          ]),
          _c("td", [
            _c("div", { staticClass: "bar" }, [
              _c("div", { staticClass: "container-bar" }, [
                _c("div", {
                  staticClass: "bar-progress",
                  style: { width: row.total + "px" }
                })
              ]),
              _c("p", { staticClass: "text-medium" }, [
                _vm._v(_vm._s(row.total))
              ])
            ])
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }